// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Description_main-container__8roq5","title":"Description_title__2PYNt","accordion":"Description_accordion__2C-yz","subheading":"Description_subheading__3TcKP"};